import { defineStore } from "pinia";
import { ref } from "vue";
import { storage } from "/@/cool/utils";

export interface Department {
	app_id: number;
	createTime: string;
	id: number;
	name: string;
	orderNum: number;
	parentId: number;
	[key: string]: any;
}

// 本地缓存
const data = storage.info();

export const useDepartmentStore = defineStore("department", function () {
	// 部门列表
	const info = ref<Department[]>(data.department || []);
	const listMap = ref<Record<number, Department>>({});
	const clickId = ref<number>(0);

	// 设置部门列表
	function set(value: any) {
		info.value = value;
		storage.set("department", value);
		setListMap(value, listMap.value);
	}

	function setListMap(value: any, listMap: Record<number, Department>) {
		value.reduce((acc: Record<number, Department>, item: Department) => {
			acc[item.id] = item;
			if (item.children?.length > 0) {
				setListMap(item.children, acc);
			}
			return acc;
		}, listMap);
	}

	// 清除部门列表
	function clear() {
		storage.remove("department");
		info.value = [];
		listMap.value = {};
	}

	// 获取部门列表
	function get() {
		return info.value;
	}

	function getTopId(id: number) {
		return listMap.value[id]?.topId || 0;
		// let topId = id;
		// console.log("id", id);
		// while (true) {
		// 	const parent = listMap.value[topId];
		// 	console.log("parent", parent);
		// 	if (parent && parent.parentId > 0) {
		// 		topId = parent.parentId;
		// 	} else {
		// 		break;
		// 	}
		// }
	}

	function isAgent(id: number) {
		// const topId = getTopId(id);
		return listMap.value[id]?.topName === "代理商";
	}

	function isDealer(id: number) {
		// const topId = getTopId(id);
		// const parent = listMap.value[topId];
		return listMap.value[id]?.topName === "经销商";
	}

	function isShop(id: number) {
		// const topId = getTopId(id);
		// const parent = listMap.value[topId];
		return listMap.value[id]?.topName === "加盟商";
	}

	function setClickId(id: number) {
		clickId.value = id;
	}

	function getCurrentMode() {
		if (isAgent(clickId.value)) {
			return 3;
		}
		if (isDealer(clickId.value)) {
			return 2;
		}
		return 1;
	}

	function getCurrentInfo() {
		return {
			...listMap.value[clickId.value],
			children: []
		};
	}

	function getCurrentTopInfo() {
		return {
			...listMap.value[getTopId(clickId.value)],
			children: []
		};
	}

	return {
		info,
		get,
		set,
		clear,
		isAgent,
		isDealer,
		isShop,
		setClickId,
		getCurrentMode,
		getCurrentInfo,
		getCurrentTopInfo
	};
});
